module.exports = {
  prefix: "tw-",
  important: true,
  corePlugins: {
    preflight: false,
  },
  content: ["./public/**/*.html", "./src/**/*.{js,jsx,ts,tsx}"],
  safelist: [{ pattern: /^mce-/ }],
  theme: {
    extend: {
      colors: {
        primary: "var(--color-primary)",
        secondary: "var(--color-secondary)",
        "page-paper-main": "var(--page-paper-main)",
        "body-bg-main": "var(--body-bg-main)",
        "primary-200": "var(--color-primary-200)",
        "primary-300": "var(--color-primary-300)",
        "theme-100": "var(--color-theme-100)",
        "theme-200": "var(--color-theme-200)",
        "theme-300": "var(--color-theme-300)",
        "theme-400": "var(--color-theme-400)",
        "theme-500": "var(--color-theme-500)",
        "theme-600": "var(--color-theme-600)",
        "theme-700": "var(--color-theme-700)",
        "theme-800": "var(--color-theme-800)",
        "theme-900": "var(--color-theme-900)",
        "border-primary": "var(--border-primary)",
        "red-alert": "var(--red-alert)",
        "green-success": "#40c37d",
        current: "currentColor",
      },
      borders: {
        "border-primary": "var(--border-primary)",
        "border-theme-primary": "var(--color-primary)",
        "border-theme-secondary": "var(--color-secondary)",
      },
      fontSize: {
        xxs: "0.6875rem",
      },
      borderRadius: {
        xl: "1rem",
      },
      boxShadow: {
        primary: "var(--shadow-primary)",
      },
    },
  },
  plugins: [require("@tailwindcss/line-clamp")],
};
